<template>
  <div>
    <el-dialog
      :title="'添加设备'"
      :close-on-click-modal="false"
      top="5%"
      :visible.sync="showDialog"
      width="40%"
      label-width="80px"
    >
      <el-form
        :model="addform"
        ref="addform"
        :rules="myrules"
        label-width="100px"
      >
        <el-form-item label="项目编号" prop="projectId">
          <el-input
            v-model.trim="addform.projectId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item label="品牌" prop="brandId">
          <el-select
            v-model="addform.brandId"
            clearable
            filterable
            @change="selectBrand"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in brandSelectData"
              :key="index"
              :label="item.brandName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店" prop="hotelId">
          <el-select
            v-model="addform.hotelId"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in hotelSelectData"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmAdd('addform')"
          :loading="loading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addKooFeeAppliance, getHotelSelect, getBrandSelect } from "@/api";
export default {
  data() {
    return {
      loading: false,
      showDialog: false,
      hotelSelectData: null,
      addform: {
        projectId: null,
        brandId: null,
        hotelId: null,
      },
      brandSelectData: null,
      type: 0,
      myrules: {
        projectId: [
          { required: true, message: "请输入", trigger: ["blur", "changge"] },
        ],
        brandId: [
          { required: true, message: "请选择", trigger: ["blur", "changge"] },
        ],
        hotelId: [
          { required: true, message: "请选择", trigger: ["blur", "changge"] },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.initialize();
  },
  methods: {
    initialize(obj) {
      getBrandSelect(obj).then((res) => {
        if (res.status === 200) {
          this.brandSelectData = res.data.data;
        }
      });
    },
    selectBrand(id) {
      this.addform.hotelId = null;
      getHotelSelect(id).then((res) => {
        if (res.data.data) {
          this.hotelSelectData = res.data.data;
        } else {
          this.$message({
            message: "该品牌下没有门店",
            type: "warning",
          });
        }
      });
    },

    confirmAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addKooFeeAppliance(this.addform).then((_) => {
            this.showDialog = false;
            this.$emit("addViewClose");
          });
          return true;
        }
        return false;
      });
    },

    openSet(data) {
      this.showDialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader {
  width: 50px !important;
  height: 50px !important;
}
.avatar-uploader-icon {
  font-size: 22px;
  color: #8c939d;
  height: 50px !important;
  line-height: 50px !important;
  text-align: center;
}
.avatar {
  height: 100px;
  padding: 5px;
  display: inline-block;
  position: relative;
  margin-right: 10px;
  overflow: hidden;
  .avatarImg {
    height: 100px;
  }
  .del {
    right: -100%;
    transition: all 0.5s;
    overflow: hidden;
  }
  &:hover {
    .del {
      transition: all 0.5s;
      border-radius: 50%;
      width: 25px;
      height: 25px;
      position: absolute;
      z-index: 5;
      right: 0;
      top: 0;
      text-align: center;
      line-height: 25px;
      background-color: rgba(0, 0, 0, 0.5);
      .delBtn {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>


